/**
 * Bota size guide: Organic Cotton range.
 *
 * <bota-size-guide data-mode="drawer"> sits in the product page size drawer
 * (snippets/size-chart-modal.liquid). <bota-size-guide data-mode="page"> sits in the
 * help centre. Both read the same data below, so a number is only ever changed here.
 *
 * CHART is the published Bota size chart. This file is public: keep factory garment
 * measurements out of it. Inseam is the one garment length Bota publishes.
 */
(function () {
  if (customElements.get('bota-size-guide')) return;

  const SIZES = ['XS', 'S', 'M', 'L', 'XL'];
  const CHART = {
    eu: ['32–34', '34–36', '38–40', '40–42', '42–44'],
    // UK and US follow from the EU ranges: UK = EU - 28, US = UK - 4.
    uk: ['4–6', '6–8', '10–12', '12–14', '14–16'],
    us: ['0–2', '2–4', '6–8', '8–10', '10–12'],
    bust: [[78, 83], [83, 89], [89, 94], [94, 99], [99, 104]],
    waist: [[58, 63], [63, 69], [69, 74], [74, 79], [79, 84]],
    hips: [[86, 91], [91, 96], [96, 102], [102, 107], [107, 112]],
  };
  const MEAS = {
    bust: { label: 'Bust', tip: 'fullest part', min: 72, max: 110 },
    waist: { label: 'Waist', tip: 'at the navel', min: 52, max: 90 },
    hips: { label: 'Hips', tip: 'fullest part', min: 80, max: 118 },
  };

  // uses: the measurements that decide the size. roomy: sized down when between sizes.
  // check: asked for and shown, but only adds a note when it sits in a larger size.
  // inseam: garment inside-leg length per size, in cm.
  const GARMENTS = {
    leggings: { name: 'Leggings', uses: ['waist', 'hips'], inseam: [71, 71, 71, 71, 71] },
    flare: { name: 'Flare leggings', uses: ['waist', 'hips'], inseam: [80, 81, 82, 83, 84] },
    shorts: { name: 'Shorts', uses: ['waist', 'hips'], inseam: [12, 12, 12, 12, 12] },
    sweatpants: { name: 'Oversized sweatpants', uses: ['waist', 'hips'], roomy: true, inseam: [77, 78, 79, 80, 81] },
    bra: { name: 'Sports bra', uses: ['bust'] },
    cami: { name: 'Cami top', uses: ['bust'], check: ['waist'] },
    halter: { name: 'Halter top', uses: ['bust'], check: ['waist'] },
    dress: { name: 'Tennis dress', uses: ['bust', 'waist', 'hips'] },
    headband: { name: 'Headband', oneSize: true },
    // Styles without their own entry are sized from the chart alone.
    bottom: { name: 'This style', uses: ['waist', 'hips'] },
  };
  const PAGE_ORDER = ['leggings', 'flare', 'shorts', 'sweatpants', 'bra', 'cami', 'halter', 'dress', 'headband'];

  /** Works out which garments a product is made of, tops first, from its title. */
  function garmentsFor(title) {
    const t = (title || '').toLowerCase();
    const out = [];
    if (t.includes('headband')) return ['headband'];
    if (t.includes('sports bra')) out.push('bra');
    if (t.includes('cami')) out.push('cami');
    if (t.includes('halter')) out.push('halter');
    if (t.includes('tennis dress')) out.push('dress');
    if (t.includes('sweatpants')) out.push('sweatpants');
    else if (t.includes('scrunch')) out.push('bottom');
    else if (t.includes('flare')) out.push('flare');
    else if (t.includes('leggings')) out.push('leggings');
    else if (t.includes('shorts')) out.push('shorts');
    return out;
  }

  /** The size system a visitor most likely knows, from the country Shopify serves them. */
  function homeRegion() {
    const country = (window.Shopify && window.Shopify.country) || '';
    if (country === 'US' || country === 'CA') return 'US';
    if (country === 'GB' || country === 'IE' || country === 'AU' || country === 'NZ') return 'UK';
    return 'EU';
  }

  const REGIONS = ['EU', 'UK', 'US'];
  // The unit each size system starts in. UK also serves Ireland, Australia and New Zealand.
  const UNITS = { EU: 'cm', UK: 'cm', US: 'in' };
  const STORE_KEY = 'bota-size-guide';
  const DEFAULTS = { unit: 'cm', region: null, vals: { bust: 86, waist: 66, hips: 94 }, input: 'measure', usual: null, touched: false };
  function loadState() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORE_KEY) || 'null');
      if (saved && saved.vals) {
        const { unit, region, input, usual, touched } = { ...DEFAULTS, ...saved };
        return { unit, region: REGIONS.includes(region) ? region : homeRegion(), input, usual, touched, vals: { ...DEFAULTS.vals, ...saved.vals } };
      }
    } catch (e) {}
    const region = homeRegion();
    return { ...DEFAULTS, region, unit: UNITS[region], vals: { ...DEFAULTS.vals } };
  }
  function saveState(st) {
    try {
      const { unit, region, vals, input, usual, touched } = st;
      localStorage.setItem(STORE_KEY, JSON.stringify({ unit, region, vals, input, usual, touched }));
    } catch (e) {}
  }

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

  const FIGURE = '<svg class="bsg__figure" viewBox="0 0 160 224" width="150" height="210" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M70 8C70 20 60 24 40 30C33 32 36 48 44 62C40 72 40 84 44 94C48 104 50 110 50 118C48 134 36 146 36 164C36 184 42 202 44 218"/><path d="M90 8C90 20 100 24 120 30C127 32 124 48 116 62C120 72 120 84 116 94C112 104 110 110 110 118C112 134 124 146 124 164C124 184 118 202 116 218"/><path d="M80 178V218" stroke-opacity=".35"/><g stroke-opacity=".6" stroke-dasharray="3 4"><ellipse cx="80" cy="78" rx="39" ry="6"/><ellipse cx="80" cy="118" rx="30" ry="5"/><ellipse cx="80" cy="162" rx="44" ry="6.5"/></g><g fill="currentColor" stroke="none"><circle cx="144" cy="78" r="9"/><circle cx="144" cy="118" r="9"/><circle cx="144" cy="162" r="9"/></g><g class="bsg__figure-num" stroke="none" font-size="10" font-weight="600" text-anchor="middle"><text x="144" y="81.5">1</text><text x="144" y="121.5">2</text><text x="144" y="165.5">3</text></g></svg>';

  class BotaSizeGuide extends HTMLElement {
    static get observedAttributes() {
      return ['data-title'];
    }

    connectedCallback() {
      if (!this.st) {
        this.st = loadState();
        this.st.tab = 'chart';
        this.st.garment = 'leggings';
        this.addEventListener('input', this.onInput);
        this.addEventListener('change', this.onChange);
        this.addEventListener('click', this.onClick);
        // The product section can be re-rendered around us; redraw if our markup is replaced.
        this.observer = new MutationObserver(() => {
          if (!this.querySelector('.bsg')) this.render();
        });
      }
      this.observer.observe(this, { childList: true });
      this.render();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    attributeChangedCallback(name, before, after) {
      if (this.st && before !== after) this.render();
    }

    get mode() {
      return this.dataset.mode === 'page' ? 'page' : 'drawer';
    }

    /** Garment keys shown for this instance. */
    get keys() {
      if (this.mode === 'page') return [this.st.garment];
      const keys = garmentsFor(this.dataset.title);
      return keys.length ? keys : ['bottom'];
    }

    garment(key) {
      const g = GARMENTS[key];
      if (key !== 'bottom') return g;
      // Name the fallback after the product, minus the brand prefix and colour.
      const name = (this.dataset.title || '').replace(/^(100% )?organic cotton /i, '').split(/ [-|] /)[0].trim();
      return { ...g, name: name || g.name };
    }

    /* ---------- maths ---------- */

    show(v) {
      if (this.st.unit === 'cm') return Number.isInteger(v) ? String(v) : v.toFixed(1);
      return String(Math.round((v / 2.54) * 2) / 2);
    }

    get u() {
      return this.st.unit === 'cm' ? 'cm' : 'in';
    }

    /** This size's label in the chosen size system, for example "UK 6–8". */
    label(i) {
      return `${this.st.region} ${CHART[this.st.region.toLowerCase()][i]}`;
    }

    indexFor(m, v) {
      const R = CHART[m];
      if (v < R[0][0]) return { i: 0, under: true };
      for (let i = 0; i < 5; i++) if (v <= R[i][1]) return { i, between: i < 4 && v >= R[i][1] - 0.5 };
      return { i: 4, over: true };
    }

    recommend(key) {
      const g = GARMENTS[key];
      const st = this.st;
      if (g.oneSize) return { one: true };
      if (st.input === 'usual') return st.usual == null ? { none: true } : { i: st.usual, from: 'usual' };
      const per = {};
      let i = -1;
      let by = null;
      let over = false;
      let under = true;
      g.uses.forEach((m) => {
        const r = this.indexFor(m, st.vals[m]);
        per[m] = r;
        if (r.i > i) {
          i = r.i;
          by = m;
        }
        if (r.over) over = true;
        if (!r.under) under = false;
      });
      const differ = g.uses.length > 1 && new Set(g.uses.map((m) => per[m].i)).size > 1;
      const r = { i, by, per, over, under, between: !!per[by].between, differ };
      const chosen = this.pick(key, r);
      (g.check || []).forEach((m) => {
        const c = this.indexFor(m, st.vals[m]);
        if (c.i > chosen && !(r.snug && r.snug.i >= c.i)) r.snug = { m, i: c.i };
      });
      return r;
    }

    /** The size the button selects: the easier size when between two, except on roomy cuts. */
    pick(key, r) {
      if (r.one || r.none) return null;
      return r.between && !r.over && !GARMENTS[key].roomy ? r.i + 1 : r.i;
    }

    verdict(key, r) {
      const [heading, text] = this.fit(key, r);
      if (!r.snug || r.over) return [heading, text];
      const m = MEAS[r.snug.m].label.toLowerCase();
      const note = `Your ${m} is in the ${SIZES[r.snug.i]} range, so the hem will fit closer.`;
      if (r.between || r.under) return [heading, `${text} ${note}`];
      return [heading, `Sized by your bust. ${note} Size up if you prefer it looser.`];
    }

    fit(key, r) {
      const g = GARMENTS[key];
      if (r.one) return ['One size', 'This style comes in one size.'];
      if (r.none) return ['Pick your usual size', 'Choose the size you normally wear and we will match it.'];
      if (r.from === 'usual') return [`Your size is ${SIZES[r.i]}`, `Matched from ${this.label(r.i)}. For a closer check, enter your measurements.`];
      const by = MEAS[r.by].label.toLowerCase();
      if (r.over) return ['XL is our largest size', `Your ${by} is above our XL range, so XL will fit closer than intended. Email us and we will advise.`];
      if (r.under) return ['XS is the closest fit', 'Your measurements are below our XS range, so XS will fit a little easier than intended.'];
      if (r.between) {
        return [
          `Between ${SIZES[r.i]} and ${SIZES[r.i + 1]}`,
          g.roomy ? `The cut is roomy, so we would take ${SIZES[r.i]}.` : `Take ${SIZES[r.i + 1]} for an easier fit, or ${SIZES[r.i]} for a firmer hold.`,
        ];
      }
      if (r.differ) return [`Your size is ${SIZES[r.i]}`, `Sized by your ${by}, the larger of your measurements, so nothing sits too tight.`];
      return [`Your size is ${SIZES[r.i]}`, g.roomy ? 'Your usual size. Size down if you prefer a neater leg.' : 'Your measurements sit comfortably in this size.'];
    }

    /* ---------- markup ---------- */

    track(m) {
      const v = this.st.vals[m];
      const r = this.indexFor(m, v);
      const R = CHART[m][r.i];
      const within = r.under ? 0.04 : r.over ? 0.96 : (v - R[0]) / (R[1] - R[0]);
      const left = ((r.i + clamp(within, 0.06, 0.94)) / 5) * 100;
      return `<div class="bsg__bar"><span class="bsg__bar-label">${MEAS[m].label}</span><div class="bsg__track">${SIZES.map(
        (s, i) => `<b class="bsg__seg${i === r.i ? ' bsg__seg--on' : ''}">${s}</b>`
      ).join('')}<i class="bsg__dot" style="left:${left}%"></i></div></div>`;
    }

    resultHtml(key, labelled) {
      const g = this.garment(key);
      const r = this.recommend(key);
      const [heading, text] = this.verdict(key, r);
      const badge = r.one ? 'One' : r.none ? '?' : r.between && !r.over ? `${SIZES[r.i]} / ${SIZES[r.i + 1]}` : SIZES[r.i];
      const pick = this.pick(key, r);
      const canSelect = this.mode === 'drawer' && pick != null;
      return `<div class="bsg__result">
        <div class="bsg__result-top">
          <div class="bsg__badge${badge.length > 3 ? ' bsg__badge--wide' : ''}">${badge}</div>
          <div>${labelled ? `<div class="bsg__label">${esc(g.name)}</div>` : ''}<p class="bsg__verdict">${heading}</p><p class="bsg__text">${text}</p></div>
        </div>
        ${!r.one && this.st.input === 'measure' ? `<div class="bsg__bars">${g.uses.concat(g.check || []).map((m) => this.track(m)).join('')}</div>` : ''}
        ${canSelect ? `<div class="bsg__cta"><button class="button" type="button" data-select="${SIZES[pick]}" data-key="${key}">Select size ${SIZES[pick]}</button></div>` : ''}
      </div>`;
    }

    inputsHtml() {
      const st = this.st;
      const keys = this.mode === 'page' ? ['dress'] : this.keys; // the help centre asks for all three once
      const need = ['bust', 'waist', 'hips'].filter((m) => keys.some((k) => (GARMENTS[k].uses || []).concat(GARMENTS[k].check || []).includes(m)));
      if (!need.length) return '';
      const measure = need
        .map((m) => {
          const M = MEAS[m];
          return `<div class="bsg__row"><label class="bsg__row-label" for="bsg-r-${m}">${M.label}<span>${M.tip}</span></label>
            <input class="bsg__range" id="bsg-r-${m}" data-m="${m}" type="range" min="${M.min}" max="${M.max}" step="1" value="${st.vals[m]}">
            <span class="bsg__num"><input data-n="${m}" inputmode="decimal" value="${this.show(st.vals[m])}" aria-label="${M.label} in ${this.u}"><i>${this.u}</i></span></div>`;
        })
        .join('');
      const usual = `<div class="bsg__chips bsg__chips--wrap" role="group" aria-label="Your usual ${st.region} size">${SIZES.map(
        (s, i) => `<button class="bsg__chip" type="button" data-usual="${i}" aria-pressed="${st.usual === i}">${this.label(i)}</button>`
      ).join('')}</div>`;
      return `<div class="bsg__tabs" role="tablist">
          <button class="bsg__tab" type="button" role="tab" data-input="measure" aria-selected="${st.input === 'measure'}">I know my measurements</button>
          <button class="bsg__tab" type="button" role="tab" data-input="usual" aria-selected="${st.input === 'usual'}">I know my usual size</button>
        </div>
        ${
          st.input === 'measure'
            ? `<div class="bsg__rows">${measure}</div>${st.touched ? '' : '<p class="bsg__fine" data-hint>Example measurements shown. Drag or type to enter yours.</p>'}`
            : `<div class="bsg__usual">${usual}</div>`
        }`;
    }

    /** The Bota size chart, with the garment's inseam added for styles that have a leg. */
    chartTable(keys) {
      const hits = new Set(keys.map((k) => this.recommend(k).i).filter((v) => v != null));
      const legKey = keys.find((k) => GARMENTS[k].inseam);
      const inseam = legKey ? GARMENTS[legKey].inseam : null;
      const range = (m, i) => `${this.show(CHART[m][i][0])}–${this.show(CHART[m][i][1])}`;
      // Waist is always shown. Bust and hips only appear for styles that are sized by them.
      const sizedBy = (m) => keys.some((k) => (GARMENTS[k].uses || []).includes(m));
      const cols = ['bust', 'waist', 'hips'].filter((m) => m === 'waist' || sizedBy(m));
      const body = `${cols.slice(0, -1).map((m) => MEAS[m].label).join(', ')} and ${cols[cols.length - 1]}`.toLowerCase();
      return `<div class="bsg__scroller"><table class="bsg__table"><thead><tr><th>Size</th><th>${this.st.region}</th>${cols.map((m) => `<th>${MEAS[m].label}</th>`).join('')}${inseam ? '<th>Inseam</th>' : ''}</tr></thead><tbody>${SIZES.map(
        (s, i) =>
          `<tr${hits.has(i) ? ' class="bsg__hit"' : ''}><th>${s}</th><td>${CHART[this.st.region.toLowerCase()][i]}</td>${cols.map((m) => `<td>${range(m, i)}</td>`).join('')}${inseam ? `<td>${this.show(inseam[i])}</td>` : ''}</tr>`
      ).join('')}</tbody></table></div><p class="bsg__fine">Measurements in ${this.st.unit === 'cm' ? 'cm' : 'inches'}. ${body.charAt(0).toUpperCase()}${body.slice(1)} are your body measurements.${
        inseam ? ` Inseam is the inside leg length of the ${esc(this.garment(legKey).name.toLowerCase())}.` : ''
      }</p>`;
    }

    detailsHtml(keys) {
      const st = this.st;
      if (keys.every((k) => GARMENTS[k].oneSize)) return '';
      const tabs = [['chart', 'Size chart'], ['how', 'How to measure']];
      const tab = tabs.some((t) => t[0] === st.tab) ? st.tab : 'chart';
      const how = `<div class="bsg__how">${FIGURE}<ol class="bsg__steps">
          <li><i>1</i><span><b>Bust.</b> Under your arms, around the fullest part of your chest.</span></li>
          <li><i>2</i><span><b>Waist.</b> Around your natural waistline, at navel level.</span></li>
          <li><i>3</i><span><b>Hips.</b> Around the fullest part, at the top of your legs.</span></li>
        </ol></div><p class="bsg__fine">Keep the tape level and snug, not tight. No tape? Use the “I know my usual size” option.</p>`;
      return `<div class="bsg__tabs" role="tablist">${tabs
        .map(([k, t]) => `<button class="bsg__tab" type="button" role="tab" data-tab="${k}" aria-selected="${tab === k}">${t}</button>`)
        .join('')}</div>${tab === 'how' ? how : this.chartTable(keys)}`;
    }

    glanceHtml() {
      if (this.st.input === 'usual' && this.st.usual == null) return '';
      const label = (key) => {
        const r = this.recommend(key);
        return r.between && !r.over ? `${SIZES[r.i]} / ${SIZES[r.i + 1]}` : SIZES[r.i];
      };
      return `<div class="bsg__label">Your Bota sizes at a glance</div>
        <div class="bsg__glance"><div><small>Tops and bras</small><b>${label('bra')}</b></div><div><small>Leggings and shorts</small><b>${label('leggings')}</b></div><div><small>Tennis dress</small><b>${label('dress')}</b></div></div>`;
    }

    /** Full redraw. Only runs when the structure changes, never while a slider is dragged. */
    render() {
      const st = this.st;
      const page = this.mode === 'page';
      const units = `<div class="bsg__units" role="group" aria-label="Units">${['cm', 'in']
        .map((k) => `<button class="bsg__chip bsg__chip--sm" type="button" data-unit="${k}" aria-pressed="${st.unit === k}">${k}</button>`)
        .join('')}</div>`;
      const styles = page
        ? `<div><div class="bsg__label">Choose a style</div><div class="bsg__chips bsg__chips--wrap" role="group" aria-label="Style">${PAGE_ORDER.map(
            (k) => `<button class="bsg__chip" type="button" data-garment="${k}" aria-pressed="${st.garment === k}">${GARMENTS[k].name}</button>`
          ).join('')}</div></div>`
        : '';
      const inputs = `<div class="bsg__block">${this.inputsHtml()}</div>`;
      const results = `<div class="bsg__block" data-out="results"></div>`;
      const regions = `<div class="bsg__units" role="group" aria-label="Size system">${REGIONS.map(
        (k) => `<button class="bsg__chip bsg__chip--sm" type="button" data-region="${k}" aria-pressed="${st.region === k}">${k}</button>`
      ).join('')}</div>`;
      const head = `<div class="bsg__head">${regions}${units}</div>`;
      this.innerHTML = `<div class="bsg bsg--${this.mode}">${head}${
        page ? `<div class="bsg__cols"><div class="bsg__col">${inputs}<div class="bsg__block" data-out="glance"></div></div><div class="bsg__col">${styles}${results}</div></div>` : `${inputs}${results}`
      }<div class="bsg__block" data-out="details"></div></div>`;
      this.update();
    }

    /** Redraws everything that depends on the numbers, leaving the inputs in place. */
    update() {
      const keys = this.keys;
      const many = keys.length > 1 || this.mode === 'page';
      const set = (name, html) => {
        const el = this.querySelector(`[data-out="${name}"]`);
        if (el) el.innerHTML = html;
      };
      set('results', keys.map((k) => this.resultHtml(k, many)).join(''));
      set('glance', this.glanceHtml());
      set('details', this.detailsHtml(keys));
    }

    /* ---------- events ---------- */

    onInput = (e) => {
      const t = e.target;
      const st = this.st;
      if (!t.dataset.m) return;
      st.vals[t.dataset.m] = +t.value;
      st.touched = true;
      const n = this.querySelector(`[data-n="${t.dataset.m}"]`);
      if (n) n.value = this.show(st.vals[t.dataset.m]);
      this.querySelector('[data-hint]')?.remove();
      this.update();
      saveState(st);
    };

    onChange = (e) => {
      const t = e.target;
      const st = this.st;
      if (!t.dataset.n) return;
      const m = t.dataset.n;
      let v = parseFloat(String(t.value).replace(',', '.'));
      if (Number.isFinite(v)) {
        if (st.unit === 'in') v *= 2.54;
        st.vals[m] = clamp(Math.round(v), MEAS[m].min, MEAS[m].max);
        st.touched = true;
        this.querySelector('[data-hint]')?.remove();
      }
      t.value = this.show(st.vals[m]);
      const range = this.querySelector(`[data-m="${m}"]`);
      if (range) range.value = st.vals[m];
      this.update();
      saveState(st);
    };

    onClick = (e) => {
      const b = e.target.closest('button');
      if (!b || !this.contains(b)) return;
      const d = b.dataset;
      const st = this.st;
      if (d.select) return this.selectSize(d.key, d.select);
      let redraw = 'render';
      if (d.tab) {
        st.tab = d.tab;
        redraw = 'update';
      } else if (d.unit) st.unit = d.unit;
      else if (d.region) {
        st.region = d.region;
        st.unit = UNITS[d.region];
      }
      else if (d.input) st.input = d.input;
      else if (d.usual != null) st.usual = +d.usual;
      else if (d.garment) st.garment = d.garment;
      else return;
      saveState(st);
      // Redraw only after the click has finished bubbling. A redraw replaces the button
      // that was clicked, and the size drawer closes on any click whose target is no
      // longer inside it.
      const again = Object.keys(d)[0];
      const value = d[again];
      setTimeout(() => {
        this[redraw]();
        // Keep keyboard users where they were after the redraw.
        this.querySelector(`button[data-${again}="${CSS.escape(value)}"]`)?.focus();
      }, 0);
    };

    /** Chooses the size in the product's own variant picker, then closes the drawer. */
    selectSize(key, size) {
      let options = [];
      try {
        options = JSON.parse(this.dataset.options || '[]');
      } catch (e) {}
      const sizeOptions = options.map((name, index) => ({ name, index })).filter((o) => /size/i.test(o.name));
      const option = sizeOptions[Math.min(this.keys.indexOf(key), sizeOptions.length - 1)];
      const picker = document.querySelector(`variant-picker[data-product-id="${this.dataset.productId}"]`);
      if (!option || !picker) return;
      const radio = [...picker.querySelectorAll(`fieldset[data-fieldset-index="${option.index}"] input[type="radio"]`)].find((input) => input.value === size);
      const select = picker.querySelector(`select[name="options[${CSS.escape(option.name)}]"]`);
      if (radio) {
        if (!radio.checked) radio.click();
      } else if (select) {
        select.value = size;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else return;
      const last = this.keys.indexOf(key) === this.keys.length - 1;
      const button = this.querySelector(`button[data-select][data-key="${key}"]`);
      if (button) {
        button.textContent = `Size ${size} selected`;
        button.setAttribute('aria-disabled', 'true');
      }
      if (last) this.closest('dialog-component')?.closeDialog?.();
    }
  }

  customElements.define('bota-size-guide', BotaSizeGuide);
})();
